import { Card, CardContent } from "@/components/ui/card";
import { 
  DollarSign, 
  Target, 
  Zap, 
  Shield, 
  BarChart3, 
  Users, 
  Search,
  MessageSquare,
  Clock
} from "lucide-react";

const features = [
  {
    icon: DollarSign,
    title: "Transparent Pricing",
    description: "No hidden fees. $98/month per listing for private sellers, $89/month for brokers + $15-$19 per qualified lead."
  },
  {
    icon: Target,
    title: "AI-Powered Matching",
    description: "Advanced algorithms connect your listings with the right buyers automatically."
  },
  {
    icon: Zap,
    title: "Instant Lead Delivery",
    description: "Receive qualified buyer inquiries within 60 seconds via email and mobile app push notifications."
  },
  {
    icon: Shield,
    title: "Verified Buyers",
    description: "All buyers are pre-screened and qualified before they can access listing details."
  },
  {
    icon: BarChart3,
    title: "Real-Time Analytics",
    description: "Track listing performance, lead quality, and conversion rates in your web and mobile app dashboard."
  },
  {
    icon: Users,
    title: "Team Management",
    description: "Add team members, assign roles, and collaborate on listings seamlessly."
  },
  {
    icon: Search,
    title: "Advanced Search",
    description: "Buyers can find exactly what they're looking for with powerful filters and search."
  },
  {
    icon: MessageSquare,
    title: "Direct Communication",
    description: "Built-in messaging system for secure broker-buyer communication."
  },
  {
    icon: Clock,
    title: "24/7 Support",
    description: "Get help when you need it with our dedicated customer success team."
  }
];

export function FeaturesSection() {
  return (
    <section id="features" className="py-20 bg-gradient-card">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl lg:text-4xl font-bold text-foreground mb-4">
            Everything You Need to Sell Businesses
          </h2>
          <p className="text-xl text-muted-foreground max-w-2xl mx-auto">
            Powerful features designed specifically for business brokers and private sellers. <br />
            <span className="text-primary font-semibold">Access everything from our web platform or mobile app.</span>
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {features.map((feature, index) => (
            <Card 
              key={index} 
              className="group hover:shadow-medium transition-all duration-300 hover:-translate-y-1 border-border/50 bg-gradient-card"
            >
              <CardContent className="p-6">
                <div className="flex items-center gap-4 mb-4">
                  <div className="p-3 bg-primary/10 rounded-lg group-hover:bg-primary/20 transition-colors">
                    <feature.icon className="h-6 w-6 text-primary" />
                  </div>
                  <h3 className="text-lg font-semibold text-foreground">
                    {feature.title}
                  </h3>
                </div>
                <p className="text-muted-foreground leading-relaxed">
                  {feature.description}
                </p>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
}